// extracted by mini-css-extract-plugin
export var fadeInAnimation = "OfficesMap-module--fadeInAnimation--73aea";
export var map = "OfficesMap-module--map--8c4ca";
export var mapWrapper = "OfficesMap-module--mapWrapper--2e5c2";
export var minusButton = "OfficesMap-module--minusButton--a82be";
export var plusButton = "OfficesMap-module--plusButton--23e14";
export var zoomButton = "OfficesMap-module--zoomButton--e0bde";
export var zoomControls = "OfficesMap-module--zoomControls--3dc24";